<script setup>
import { useConfigsStore } from '@/stores/configs'
import { isString, trim, isEqual } from 'lodash-es'
import { binder } from '..'
import { computedWithControl } from '@vueuse/core'
import { inject, shallowRef, watch, ref } from 'vue'
const { get } = useConfigsStore()
const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  options: [Array, Object, String],
  return: {
    // value,object
    type: String,
    default: 'value',
  },
  modelValue: null,
  keys: {
    type: String,
    default: 'id',
  },
  optionsDepend: {
    type: Array,
    default: () => [],
  },
})
const currentValue = shallowRef(null)
const optionsFromConfig = get(props.options, [])
const formModel = inject('ss:model')
const optionsFromDepend = ref([])
const _options = computedWithControl(
  () => [props.options, optionsFromConfig, optionsFromDepend.value],
  () => {
    if (optionsFromDepend.value?.length) {
      return optionsFromDepend.value.reduce((memo, item) => {
        memo[item.id] = item.value
        return memo
      }, {})
    }
    if (isString(props.options)) {
      return optionsFromConfig.value.reduce((memo, item) => {
        memo[item.id] = item.value
        return memo
      }, {})
    }
    if (Array.isArray(props.options)) {
      return [...props.options]
    }

    if (!props.options) {
      return []
    }

    return Object.keys(props.options).reduce((memo, key) => {
      memo[props.options[key]] = key
      return memo
    }, {})
  }
)
watch(
  () => props.modelValue,
  (mv, mvo) => {
    if (!mv) {
      return
    }

    if (props.return == 'id-object' && mv.id) {
      currentValue.value = mv.id
      return
    }
    if (props.return == 'object' && mv && !isEqual(mv, mvo)) {
      currentValue.value = mv[props.keys]
      return
    }
    currentValue.value = mv
  },
  {
    immediate: true,
  }
)
watch(
  formModel,
  function (m, om) {
    let opts = []
    for (const [fieldName, fieldVal, confPath] of props.optionsDepend) {
      const currval = m[fieldName]
      if (om && currval && currval.id == om[fieldName]) {
        continue
      }
      if (currval?.id != fieldVal) {
        continue
      }
      opts = get(confPath, []).value
      break
    }
    optionsFromDepend.value = opts
  },
  { immediate: true }
)
function onInput({ currentTarget }) {
  let val = currentTarget.value
  let options

  if (optionsFromDepend.value?.length) {
    options = [...optionsFromDepend.value]
  } else if (isString(props.options)) {
    options = optionsFromConfig.value
  } else if (Array.isArray(props.options)) {
    options = [...props.options]
  } else {
    options = { ...props.options }
  }

  if (['object', 'id-object'].includes(props.return)) {
    val = options.find(({ id }) => id == val)
  }

  if (props.return == 'id-object' && val) {
    val = { id: val.id }
  }

  emit('update:modelValue', val)
}
</script>
<template>
  <select @input="onInput" v-bind="binder" class="form-select">
    <option />
    <option
      v-for="(label, value) of _options"
      :value="value"
      :key="trim(value)"
      :selected="value == currentValue"
    >
      {{ label }}
    </option>
  </select>
</template>
